import React from 'react';
import Logo from './logo-animated.svg?react';
import { useResolveMantineColor } from 'src/UI/theme/theme';

type Props = {
  height?: string | number | undefined;
  width?: string | number | undefined;
  color?: string;
};

export default function AnimatedLogoIcon({ height, width, color = 'white' }: Props) {
  const resolvedColour = useResolveMantineColor(color);

  return (
    <Logo
      style={{ color: resolvedColour }}
      fill="currentColor"
      height={height || 100}
      width={width}
    />
  );
}
